if (!customElements.get('blinc-launch-countdown')) {
  customElements.define('blinc-launch-countdown',class extends HTMLElement {
    connectedCallback() {
      const update = () => {
        const seconds = Math.max(0,Math.floor((Date.parse(this.dataset.launch)-Date.now())/1000));
        const days = Math.floor(seconds/86400), hours = Math.floor(seconds%86400/3600), minutes = Math.floor(seconds%3600/60);
        for (const [unit,value] of Object.entries({days,hours,minutes,seconds:seconds%60})) {
          const output = this.querySelector(`[data-${unit}]`);
          if (output) output.textContent = String(value).padStart(2,'0');
        }
      };
      update(); this.timer = setInterval(update,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
